import Archive from '@components/Icons/Archive';
import CheckCircle from '@components/Icons/CheckCircle';
import Files from '@components/Icons/Files';
import Binoculars from '@components/Icons/Binoculars';
import Clock from '@components/Icons/Clock';
import Globe from '@components/Icons/Globe';
import Lightbulb from '@components/Icons/Lightbulb';
import Lock from '@components/Icons/Lock';
import Microphone from '@components/Icons/Microphone';
import PaymentCheck from '@components/Icons/PaymentCheck';
import PencilSimple from '@components/Icons/PencilSimple';
import Question from '@components/Icons/Question';
import Star from '@components/Icons/Star';
import Tag from '@components/Icons/Tag';
import Signature from '@components/Icons/Signature';
import Trash from '@components/Icons/Trash';
import HourglassHigh from '@components/Icons/FiledAndPending';
import Empty from '@components/Icons/Empty';
import { createElement } from "react";
import { StatusIcons } from "@/typings/api-models";

export const optionsToIcon = {
  'Archive': Archive,
  'Binoculars': Binoculars,
  'CheckCircle': CheckCircle,
  'Clock': Clock,
  'Empty': Empty,
  'Files': Files,
  'Globe': Globe,
  'HourglassHigh': HourglassHigh,
  'Lightbulb': Lightbulb,
  'Lock': Lock,
  'Microphone': Microphone,
  'PaymentCheck': PaymentCheck,
  'PencilSimple': PencilSimple,
  'Question': Question,
  'Signature': Signature,
  'Star': Star,
  'Tag': Tag,
  'Trash': Trash,
};

type Props = {
  iconKey: StatusIcons;
  colour: string;
  size?: number;
};

const CustomStatusIcon: React.FC<Props> = ({ iconKey, colour, size = 16 }) => createElement(optionsToIcon[iconKey], { color: colour, size });

export default CustomStatusIcon;
